module.exports = __webpack_public_path__ + "fonts/e88bd0f459b926762ac8a8e8c22995e4.svg";